module.exports = __webpack_public_path__ + "static/img/11.d25e22b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/11.png
// module id = jNtB
// module chunks = 0